import { Outlet, useMatches } from 'react-router-dom';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Footer from '../shared/Footer/Footer';
import Header from './Header';

const RootLayout = styled('div')`
	display: grid;
	grid-template-columns: auto;
	grid-template-rows: auto 1fr auto;
	grid-template-areas:
		'header'
		'main'
		'footer';
	min-height: 100vh;

	.header {
		grid-area: header;
		min-height: 64px;
	}

	.main {
		grid-area: main;
	}

	.footer {
		grid-area: footer;
	}
`;

const NetworkSearchLayout = () => {
	const matches = useMatches();
	const isFullWidth = matches.some(match => match.handle?.fullWidth);

	return (
		<RootLayout>
			<Header />
			<Box
				sx={{
					width: '100%',
					maxWidth: isFullWidth ? '100%' : 1200,
					mx: 'auto',
					pb: 4,
					px: 2,
					py: 4,
				}}
			>
				<Outlet />
			</Box>
			<Footer />
		</RootLayout>
	);
};

export default NetworkSearchLayout;
